import {
  done,
  answer,
  question,
  isDocx,
  step,
  isPerinstall,
  lastStep,
} from "./data";
import { getStorage } from "@/utils/storage";
import { addFetchEncrypt, sleep, isColor } from "@/utils/index";
import axios from "axios";
import { getJiebaApi } from "@/api/gpt";
import { gptApi } from "@/config/apiDomain";
import decrypt from "@/utils/decrypt";
import router from "@/router";

//初始化AbortController
let abortController: AbortController;
const back = ref(false);

const goBack = () => {
  back.value = true;
  if (lastStep.value === "next") {
    router.go(-1);
    return;
  }
  if (step.value == "slide-ppt") {
    step.value = "template";
    return;
  }
  if (step.value == "template") {
    step.value = isPerinstall.value ? "preinstall-generation" : "generation";
    return;
  }
  step.value = lastStep.value;
};

const goBackTotheme = () => {
  back.value = true;
  answer.value = "";
  done.value = false;
  stopSendMsg();
  step.value = "theme";
};

const stopSendMsg = () => {
  if (abortController) abortController.abort();
};

const resendMsg = () => {
  if (abortController) abortController.abort();
  setTimeout(() => {
    sendMsg(question.value, isDocx.value);
  }, 100);
};

const addQueryToUrl = (param: any, url: string) => {
  // 判断是否有问号
  if (url.indexOf("?") !== -1) {
    url += "&";
  } else {
    url += "?";
  }
  for (let key in param) {
    if (["", null, undefined].includes(param[key])) continue;
    // 获取 ？ 后的参数，如果有重复的，去除
    let paramsUrl = url.split("?")[1];
    if (paramsUrl.indexOf(key) > -1) continue;
    url = url + `${key}=${param[key]}&`;
  }
  return url.slice(0, -1);
};
const sendMsg = (
  keyword: string,
  isDocxFile: number,
  isPerinstall: boolean = false
) => {
  done.value = false;
  answer.value = "";
  question.value = keyword;
  isDocx.value = isDocxFile;
  //是否是预设问题
  if (isPerinstall) {
    sendPerinstallMsg(keyword);
  } else {
    sendMessage();
  }
};

const sendMessage = () => {
  return new Promise(async (resolve) => {
    try {
      abortController = new AbortController();
      const headerObj: any = {
        "Content-Type": "application/json",
        Authorization: getStorage("token"),
      };
      const data: any = {
        model: 0,
        messages: [
          {
            role: "system",
            content: question.value
              .trim()
              .replace(/[\r\n]/g, "")
              .replace(/" "/g, "")
              .replace(/"/g, "'")
              .slice(0, 3000),
          },
        ],
        mode: 0,
        is_version4_enable_conversation: false,
        is_internet: false,
        is_version4: false,
        ppt_type: isDocx.value,
        is_ppt: true,
        temperature: 0,
        unSlow: true,
      };
      const fetchOptions: any = {
        method: "POST",
        timeout: 10000, // 设置超时时间为10秒
        headers: headerObj,
        body: JSON.stringify(data),
        signal: abortController.signal,
      };
      let ekey = getStorage("ekey");
      let apiUrl = addQueryToUrl({ ekey }, gptApi);
      const {
        url: encryptUlr,
        data: encryptBody,
        header: encryptHeaders,
      } = addFetchEncrypt({
        url: apiUrl,
        data: fetchOptions.body,
        header: fetchOptions.headers,
      });
      apiUrl = encryptUlr;
      fetchOptions.body = JSON.stringify(encryptBody);
      fetchOptions.headers = encryptHeaders;
      const res = await fetch(apiUrl, fetchOptions);
      if (res.status == 403) {
        receptionMsg("unLogin");
      } else if (res.status > 300) {
        receptionMsg("error");
      } else {
        const r = res.body;
        const d = new TextDecoder("utf8");
        const reader: any = await r?.getReader();
        let fullText = "";
        while (true) {
          const { value, done } = await reader?.read();
          const decodedString = d.decode(value);
          if (res.status >= 300) {
            resolve("");
            break;
          }
          if (done) {
            receptionMsg("done");
            resolve("");
            break;
          }
          let arr = decodedString.split("\n");
          for (let i = 0; i < arr.length; i++) {
            if (arr[i] === "" || arr[i] === "data:[DONE]") {
              continue;
            }
            let substr: any = arr[i].slice(5);
            substr = decrypt(substr);
            // 长连接获取到的数据
            const data = substr;
            if (data.message) {
              fullText += data.message;
              receptionMsg(fullText);
            }
          }
        }
      }
    } catch (e: any) {
      console.log(e, "looking for catch");

      receptionMsg("error");
      // 获取 pinia 数据
      resolve("fail");
    }
  });
};

const sendPerinstallMsg = async (keyword: string) => {
  back.value = false;
  answer.value = "";
  const content = await import(`../preinstall/${keyword}.js`);
  await sleep(1500);

  const text = content.default;
  for (let i = 0; i < text.length; i++) {
    if (back.value) break;
    const str = text[i];
    answer.value += str;
    await sleep(10);
  }
  receptionMsg("done");
};

const receptionMsg = (e: string, errType: string = "") => {
  if (e == "done") {
    if (answer.value.indexOf("#") == -1) return;
    done.value = true;
    return;
  } else if (e === "error") {
    answer.value = "请求失败";
  } else if (errType === "error: unLogin") {
    answer.value = "无效的token，请重新登录";
  } else {
    if (e.indexOf("```") == 0) answer.value = e.replace("```", "");
    else answer.value = e;
  }
};

const getImageBase64 = async (text: string, imgNum: number = 1) => {
  const API_KEY = "40680710-ee42b0abeef879432a0ab67db";
  //获取图片的数量，如果imageNum小于3，就取3，如果大于3，就取imageNum数
  const imgNumparam = imgNum < 3 ? 3 : imgNum;
  const imgList = [];
  // 发送POST请求，拆分字符串
  const res: any = await getJiebaApi({
    texts: [text],
  });
  const splitTexts = res.words[text] || "";
  let images = [];
  // 遍历拆分后得到的字符串，进行图片搜索
  for (let i = 0; i < splitTexts.length; i++) {
    const res = await axios.get(
      `https://pixabay.com/api/?key=${API_KEY}&lang=zh&q=${encodeURIComponent(
        splitTexts[i]
      )}&per_page=${imgNumparam}&image_type=photo&safesearch=true`
    );
    images = res.data.hits;
    if (images.length >= imgNum) break;
  }
  // return images;
  if (images.length > 0) {
    //根据imgNum的值，就取多少images的值，转换成base64编码，放到imgList中
    for (let i = 0; i < imgNum; i++) {
      // const imgRes = await axios.get(images[i].webformatURL, {
      //   responseType: 'arraybuffer'
      // });
      // const imgBase64: string = btoa(
      //   new Uint8Array(imgRes.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
      // );
      // imgList.push(`data:image/jpeg;base64,${imgBase64}`);
      imgList.push(images[i].webformatURL);
    }
    return imgList;
  } else {
    return [""];
  }
};

const isProd = process.env.NODE_ENV === "production";
const getBackground = async (customTheme: string, name = "white") => {
  // 默认背景，无背景返回url
  if (customTheme) {
    if (isColor(customTheme)) {
      return {
        type: "solid",
        color: customTheme,
      };
    } else {
      // const base64String = await pathToBase64(`/images/custom/${customTheme}/${name}.png`);
      const url = `${
        isProd ? "" : window.location.origin
      }/images/custom/${customTheme}/${name}.png`;
      return {
        type: "image",
        color: "#ffffff",
        image: url,
        imageSize: "cover",
      };
    }
  } else {
    return {
      type: "solid",
      color: "#fff",
    };
  }
};

const getThemePic = (customTheme: string, name = "white") => {
  const url = `${
    isProd ? "" : window.location.origin
  }/images/custom/${customTheme}/${name}.png`;
  return url;
};

export {
  sendMsg,
  stopSendMsg,
  sendMessage,
  resendMsg,
  goBack,
  goBackTotheme,
  getImageBase64,
  getBackground,
  getThemePic,
};
